import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-editable-textarea-with-links',
  templateUrl: './editable-textarea-with-links.component.html',
  styleUrls: ['./editable-textarea-with-links.component.scss']
})
export class EditableTextareaWithLinksComponent implements OnInit {
  @Input() textValue = '';
  @Input() maxNumberOfCharacters = 100;
  @Input() placeholderText?: string;
  @Input() isHighlighted = false;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<string>();
  numberOfCharacters = 0;

  ngOnInit(): void {
    this.updateCharacterCount(this.textValue || '');
    this.setContent(this.textValue);
  }

  private updateCharacterCount(value: string): void {
    this.numberOfCharacters = value.length;
  }

  private setContent(value: string): void {
    const element = document.querySelector('.editable-textarea') as HTMLElement;
    const htmlValue = this.convertTextToHTML(value);
    element.innerHTML = htmlValue;
  }

  onInput(event: InputEvent): void {
    const element = event.target as HTMLElement;
    let newValue = element.innerText;
    if (newValue.length > this.maxNumberOfCharacters) {
      newValue = newValue.slice(0, this.maxNumberOfCharacters);
      element.innerText = newValue;
    }
    const htmlValue = this.convertTextToHTML(newValue);
    element.innerHTML = htmlValue;
    this.restoreCursorPosition();
    this.updateCharacterCount(element.innerText);
    this.valueChange.emit(element.innerText);
  }

  private convertTextToHTML(text: string): string {
    const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(urlPattern, '<a href="$1" target="_blank" rel="noopener noreferrer" class="link" contenteditable="false">$1</a>');
  }

  onKeyDown(event: KeyboardEvent): void {
    const element = event.target as HTMLElement;
    const currentLength = element.innerText.length;

    if (currentLength >= this.maxNumberOfCharacters && event.key !== 'Backspace' && event.key !== 'Delete') {
      event.preventDefault();
    }
  }

  private restoreCursorPosition() {
    const element = document.querySelector('.editable-textarea') as HTMLElement;
    const range = document.createRange();
    const selection = window.getSelection();

    range.selectNodeContents(element);
    range.collapse(false);
    selection?.removeAllRanges();
    selection?.addRange(range);
  }
}
